import { getRoot, Instance, types } from 'mobx-state-tree';
import { PageModel, PageRoutes, RootType } from '../../../internal';

export const KreirajKvizModel = types
  .compose(
    PageModel,
    types.model({
      name: types.optional(types.string, ''),
      description: types.optional(types.string, ''),
      quizType: types.optional(types.string, ''),
      isActive: types.optional(types.boolean, false),
      startDate: types.optional(types.string, ''),
      endDate: types.optional(types.string, ''),
      resultsVisibleUntil: types.optional(types.string, ''),
      startTime: types.optional(types.string, ''),
      endTime: types.optional(types.string, ''),
      dailyWinnersCount: types.optional(types.number, 1),
    })
  )
  .views((self) => ({
    get root(): RootType {
      return getRoot(self);
    },
    get isValid(): boolean {
      return (
        !!self.name.trim() &&
        !!self.quizType &&
        !!self.startDate &&
        !!self.endDate &&
        !!self.startTime &&
        !!self.endTime
      );
    },
  }))
  .actions((self) => ({
    setName(value: string) {
      self.name = value;
    },
    setDescription(value: string) {
      self.description = value;
    },
    setQuizType(value: string) {
      self.quizType = value;
    },
    setIsActive(value: boolean) {
      self.isActive = value;
    },
    setStartDate(value: string) {
      self.startDate = value;
    },
    setEndDate(value: string) {
      self.endDate = value;
    },
    setResultsVisibleUntil(value: string) {
      self.resultsVisibleUntil = value;
    },
    setStartTime(value: string) {
      self.startTime = value;
    },
    setEndTime(value: string) {
      self.endTime = value;
    },
    setDailyWinnersCount(value: number) {
      self.dailyWinnersCount = value;
    },
    async beforePageEnter() {
      self.name = '';
      self.description = '';
      self.quizType = '';
      self.isActive = false;
      self.startDate = '';
      self.endDate = '';
      self.resultsVisibleUntil = '';
      self.startTime = '';
      self.endTime = '';
      self.dailyWinnersCount = 1;
      return Promise.resolve(true);
    },
    navigateBack() {
      self.root.router.navigate({ newView: PageRoutes.SviKvizovi.id });
    },
    async submit() {
      const payload: any = {
        name: self.name.trim(),
        quizType: self.quizType,
        isActive: self.isActive,
        startDate: self.startDate,
        endDate: self.endDate,
        startTime: self.startTime,
        endTime: self.endTime,
        dailyWinnersCount: self.dailyWinnersCount,
      };
      if (self.description.trim())
        payload.description = self.description.trim();
      if (self.resultsVisibleUntil)
        payload.resultsVisibleUntil = self.resultsVisibleUntil;
      try {
        await self.root.api.quiz.createQuiz(payload);
        (this as any).navigateBack();
      } catch (err: any) {
        const message =
          err?.response?.data?.message ??
          'Došlo je do greške pri čuvanju kviza.';
        self.root.showFailure(message, null);
      }
    },
  }))
  .named('KreirajKvizModel');

export type KreirajKvizModelType = Instance<typeof KreirajKvizModel>;
